odoo.define('@web/session', [], function (require) {
'use strict';
let __exports = {};
const session = __exports.session = odoo.__session_info__ || {};
delete odoo.__session_info__;

return __exports;
});
